import { Suspense } from 'react';
import { Outlet } from 'react-router';

export function ExternalPages() {
  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
}
